import React, { createContext, useContext } from 'react';
import PropTypes from 'prop-types';
import Locales from '../locales';
import UserStore from '../stores/UserStore';
import { getTranslation } from '../helpers/translationHelper';

// Create I18n Context
const I18nContext = createContext();

// Provider component
export const I18nProvider = ({ children }) => {
    const locale = UserStore.getLocale();
    const t = Locales[locale] || {};
    
    return (
        <I18nContext.Provider value={{ t }}>
            {children}
        </I18nContext.Provider>
    );
};

export const useI18n = () => {
    const context = useContext(I18nContext);
    if (!context) {
        throw new Error('useI18n must be used within an I18nProvider');
    }
    return context;
};

// Legacy component for backward compatibility
const ChildrenContext = ({ children }) => {
    return children;
};

ChildrenContext.propTypes = {
    children: PropTypes.node
};

export default ChildrenContext;